import { MappedClass, MappedProperty } from '@h5s/util-object';
import { OutOfServiceReasonCode } from './out-of-service-reason-code';

export interface ZPrinterFiscalOutOfServiceRequestFields {
  reason_code: OutOfServiceReasonCode;
  note: string | null;
}

@MappedClass()
export class ZPrinterFiscalOutOfServiceRequest implements ZPrinterFiscalOutOfServiceRequestFields {
  @MappedProperty()
  reason_code: OutOfServiceReasonCode;

  @MappedProperty()
  note: string | null;

  constructor(fields: ZPrinterFiscalOutOfServiceRequestFields) {
    Object.assign(this, fields);
  }
}
